(function () {
   var COOKIE_NAME = 'ldDeviceId';
   var COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 365 * 2;
   var COOKIE_DOMAIN = '.lazydogrestaurants.com';

   function isLazyDogHost() {
     var host = window.location.hostname;
     return host === 'lazydogrestaurants.com' || host.endsWith('.lazydogrestaurants.com');
   }

   function readDeviceIdCookie() {
     var cookies = document.cookie ? document.cookie.split('; ') : [];
     for (var i = 0; i < cookies.length; i++) {
       var eq = cookies[i].indexOf('=');
       if (eq === -1) continue;
       if (cookies[i].slice(0, eq) === COOKIE_NAME) {
         try { return decodeURIComponent(cookies[i].slice(eq + 1)); }
         catch (e) { return null; } // malformed value — pretend it's absent
       }
     }
     return null;
   }

   function writeDeviceIdCookie(id) {
     document.cookie = [
       COOKIE_NAME + '=' + encodeURIComponent(id),
       'Domain=' + COOKIE_DOMAIN,
       'Path=/',
       'Max-Age=' + COOKIE_MAX_AGE_SECONDS,
       'Secure',
       'SameSite=Lax'
     ].join('; ');
   }

   function hasAnalyticsConsent() {
     try { return window.Termly && window.Termly.getConsentState().analytics === true; }
     catch (e) { return false; }
   }

   function pushDeviceIdToDataLayer(id) {
     window.dataLayer = window.dataLayer || [];
     window.dataLayer.push({ ld_device_id: id });
   }

   var issued = false;
   function tryIssue() {
     if (issued) return;
     if (!hasAnalyticsConsent()) return;
     var id = readDeviceIdCookie();
     if (id == null) {
       if (!isLazyDogHost()) return; // myshopify preview / unknown host — skip
       id = crypto.randomUUID();
       writeDeviceIdCookie(id);
     }
     pushDeviceIdToDataLayer(id);
     issued = true;
   }

   function attach() {
     tryIssue();
     if (window.Termly && typeof window.Termly.on === 'function') {
       window.Termly.on('consent', tryIssue);
     }
   }

   if (window.Termly) {
     attach();
   } else {
     var observer = new MutationObserver(function () {
       if (window.Termly) { observer.disconnect(); attach(); }
     });
     observer.observe(document.documentElement, { childList: true, subtree: true });
   }
 })();